import { render, staticRenderFns } from "./RichTextWidget.vue?vue&type=template&id=0e4276c4&scoped=true"
import script from "./RichTextWidget.vue?vue&type=script&lang=js"
export * from "./RichTextWidget.vue?vue&type=script&lang=js"
import style0 from "./RichTextWidget.vue?vue&type=style&index=0&id=0e4276c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4276c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4276c4')) {
      api.createRecord('0e4276c4', component.options)
    } else {
      api.reload('0e4276c4', component.options)
    }
    module.hot.accept("./RichTextWidget.vue?vue&type=template&id=0e4276c4&scoped=true", function () {
      api.rerender('0e4276c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/RichTextWidget.vue"
export default component.exports